import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingConfig, intl, listing } = props;
  const { listingFields } = listingConfig || {};

  if (!publicData || !listingConfig) {
    return null;
  }

  // Obtener nombre del autor (OWNER)
  let authorName = '';
  if (listing && listing.author && listing.author.attributes && listing.author.attributes.profile) {
    authorName = listing.author.attributes.profile.displayName;
  } else if (publicData.owner) {
    authorName = publicData.owner;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, includeForListingTypes, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType =
      includeForListingTypes == null || includeForListingTypes.includes(listingType);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue || metadataValue;

    if (isDetail && isTargetListingType && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFields.reduce(pickListingFields, []);

  // Mapeo de listingType (CONDITION)
  const conditionLabels = {
    'sell-used-products': 'Used',
    'new': 'New',
    'refurbished': 'Refurbished',
    'closeout': 'Closeout',
  };

  // Arrays de categorías y subcategorías (copiados de SearchPage)
  const categories = [
    { label: 'Hunting & Outdoors', category: 'hunting' },
    { label: 'Archery', category: 'archery' },
    { label: 'Fishing', category: 'fishing' },
  ];
  const subcategories = [
    { label: 'Bows', option: 'bows-onlyarchery', parentCategory: 'archery' },
    { label: 'Crossbows', option: 'crossbows-onlyarchery', parentCategory: 'archery' },
    { label: 'Archery Accessories', option: 'archery-accessories-onlyarchery', parentCategory: 'archery' },
    { label: 'Bowfishing', option: 'bowfishing-onlyarchery', parentCategory: 'archery' },
    { label: 'Arrows', option: 'arrows-onlyarchery', parentCategory: 'archery' },
    { label: 'Broadheads', option: 'broadheads-onlyarchery', parentCategory: 'archery' },
    { label: 'Targets', option: 'targets-onlyarchery', parentCategory: 'archery' },
    { label: 'Competition Archery', option: 'competition-archery-onlyarchery', parentCategory: 'archery' },
    { label: 'Hunting Apparel', option: 'hunting-apparel-onlyhunting', parentCategory: 'hunting' },
    { label: 'Treestands', option: 'treestands-onlyhunting', parentCategory: 'hunting' },
    { label: 'Hunting Blinds', option: 'hunting-blinds-onlyhunting', parentCategory: 'hunting' },
    { label: 'Knives', option: 'knives-onlyhunting', parentCategory: 'hunting' },
    { label: 'Tools', option: 'tools-onlyhunting', parentCategory: 'hunting' },
    { label: 'Optics', option: 'optics-onlyhunting', parentCategory: 'hunting' },
    { label: 'Dog Training', option: 'dog-training-onlyhunting', parentCategory: 'hunting' },
    { label: 'Game Processing', option: 'game-processing-onlyhunting', parentCategory: 'hunting' },
    { label: 'Game Calls', option: 'game-calls-onlyhunting', parentCategory: 'hunting' },
    { label: 'Game Cameras', option: 'game-cameras-onlyhunting', parentCategory: 'hunting' },
    { label: 'Packs', option: 'packs-onlyhunting', parentCategory: 'hunting' },
    { label: 'Rod & Reels', option: 'rod-reels-onlyfishing', parentCategory: 'fishing' },
    { label: 'Baits & Lures', option: 'baits-lures-onlyfishing', parentCategory: 'fishing' },
    { label: 'Line/Hooks', option: 'line-hooks-onlyfishing', parentCategory: 'fishing' },
    { label: 'Electronics', option: 'electronics-onlyfishing', parentCategory: 'fishing' },
    { label: 'Fishing Apperal/Waders', option: 'fishing-apperal-onlyfishing', parentCategory: 'fishing' },
    { label: 'Ice Fishing', option: 'ice-fishing-onlyfishing', parentCategory: 'fishing' },
  ];

  // Extraer datos dinámicos
  const condition = conditionLabels[publicData?.listingType] || '';
  const subcategory = subcategories.find(s => s.option === publicData?.subcategory)?.label || '';
  const category = categories.find(c => c.category === publicData?.category)?.label || '';
  const associate = publicData?.associate || '';

  // Construir el título de forma flexible
  let dynamicTitle = '';
  if (condition || subcategory || category) {
    dynamicTitle += [condition, subcategory, category].filter(Boolean).join(' ');
  }
  if (authorName) {
    dynamicTitle += (dynamicTitle ? ' sold by ' : 'Sold by ') + authorName;
  }
  if (associate) {
    dynamicTitle += (authorName ? ' from ' : 'From ') + associate;
  }

  return existingListingFields.length > 0 ? (
    <div className={css.sectionDetails}>
      {dynamicTitle && (
        <div className={css.detailsHighlightTitle}>{dynamicTitle}</div>
      )}
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={css.details}>
        {existingListingFields.map(detail => (
          <li key={detail.key} className={css.detailsRow}>
            <span className={css.detailLabel}>{detail.label}</span>
            <span>{detail.value}</span>
          </li>
        ))}
        {publicData && publicData.isHandcrafted && (
          <li className={css.detailsRow}>
            <span className={css.detailLabel}>{<FormattedMessage id="ListingPage.isHandcrafted" />}</span>
            <span>{publicData.isHandcrafted === true || publicData.isHandcrafted === "true" ? "Yes" : "No"}</span>
          </li>
        )}
      </ul>
    </div>
  ) : null;
};

export default SectionDetailsMaybe;
